import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Container,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useSelector } from "react-redux";
export default function Dashboard() {
  const { usuario } = useSelector((state) => state.user);
  const [TipoUsuario, setTipoUsuario] = React.useState("");

  React.useEffect(() => {
    switch (usuario.TipoUsuario) {
      case "1":
        setTipoUsuario("Administrador");
        break;
      case "2":
        setTipoUsuario("Gerente");
        break;
      case "3":
        setTipoUsuario("Contador");
        break;
      case "4":
        setTipoUsuario("ControlExistencias");
        break;
      case "5":
        setTipoUsuario("Comercio Exterior");
        break;
      case "6":
        setTipoUsuario("Digitador");
        break;
      case "7":
        setTipoUsuario("Bodega");
        break;
      case "8":
        setTipoUsuario("Ventas");
        break;
      case "9":
        setTipoUsuario("Jefe de Area");
        break;
      case "N":
        setTipoUsuario(
          "NoUsuario. Sólo puede digitar su Rut para recibir viáticos."
        );
        break;
      case "S":
        setTipoUsuario(
          "Sin acceso al sistema. No puede hacer nada en el sistema."
        );
        break;
      default:
        setTipoUsuario(
          "Sin acceso al sistema. No puede hacer nada en el sistema."
        );
        break;
    }
  }, [usuario.TipoUsuario]);

  return (
    <Container maxWidth="xs sm" sx={{ mt: 1 }}>
      <Box sx={{ color: "text.primary", fontSize: 20, fontWeight: "medium" }}>
        <Box sx={{ color: "text.primary", fontSize: 13, fontWeight: "medium" }}>
          <Card sx={{ maxWidth: "md xs" }}>
            <CardActionArea>
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  <AccountCircle
                    sx={{ color: "action.active", mr: 1, my: 0.5 }}
                  />{" "}
                  Datos de Usuario
                </Typography>

                <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                  <TextField
                    id="input-with-sx"
                    label="Rut"
                    variant="standard"
                    fullWidth
                    disabled
                    value={usuario.RutFormato}
                  />
                </Box>
                <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                  <TextField
                    id="input-with-sx"
                    label="Nombre"
                    variant="standard"
                    fullWidth
                    disabled
                    value={
                      usuario.Nombre +
                      " " +
                      usuario.Paterno +
                      " " +
                      usuario.Materno
                    }
                  />
                </Box>
                <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                  <TextField
                    id="input-with-sx"
                    label="Dirección"
                    variant="standard"
                    fullWidth
                    disabled
                    value={usuario.Direccion}
                  />
                </Box>
                <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                  <TextField
                    id="input-with-sx"
                    label="Teléfono"
                    variant="standard"
                    fullWidth
                    disabled
                    value={usuario.Telefono}
                  />
                </Box>
                <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                  <TextField
                    id="input-with-sx"
                    label="Tipo Usuario"
                    variant="standard"
                    fullWidth
                    disabled
                    value={TipoUsuario}
                  />
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        </Box>
      </Box>
      {/* </Box> */}
    </Container>
  );
}
